export const getBoolean = [
  { id: 0, name: "False", value: false },
  { id: 1, name: "True", value: true },
];

export const duation = [
  { id: 0, name: "1 hour", value: 1 },
  { id: 1, name: "2 hours", value: 2 },
];
